module.exports = __webpack_public_path__ + "static/media/esgi.cdb0b5d9.jpg";